module.exports = __webpack_public_path__ + "static/media/IAP_SplitSale@3x.b146d997.png";